import { t } from '@lingui/macro';
import React from 'react';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer/LegendRenderer';
import { ROAD_ROUGHNESS_GRADIENT_LEGEND } from '../../../constants/legends';

/**
 * AggHexRiLegend - Легенда индекса неровности дороги (Road Index)
 * Мигрирована на новую систему легенд (Этап 3)
 * Использует GradientLegend компонент через LegendRenderer
 */

const aggHexRiComponent = () => (
    <LegendRenderer config={ROAD_ROUGHNESS_GRADIENT_LEGEND} />
);

export const AggHexRiLegend = withDisplayedLayersCheck(
    aggHexRiComponent,
    `${t`Неровность дороги`} (${t`вчера`})`
);

